import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { Game } from './../../model/Game';
import { GameService } from './../../services/game.service';

@Component({
  selector: 'app-level-selector',
  templateUrl: './level-selector.component.html',
  styleUrls: ['./level-selector.component.less'],
  animations: [
    trigger(
      'menuAnimation',
      [

        transition(
          ':enter',
          [
            style({ bottom: "100vh", top: "-100vh", opacity: 0 }),
            animate('0.4s ease-in-out',
              style({ bottom: "2vh", top: "10vh", opacity: 1 })),
            animate('0.3s ease-in-out',
              style({ bottom: "8vh", top: "3vh", opacity: 1 })),


          ]
        ),
        transition(
          ':leave',
          [
            animate('0.2s 0.3s ease-in-out',
              style({ bottom: "2vh", top: "10vh", opacity: 1 })),
            animate('0.6s ease-in-out',
              style({ bottom: "100vh", top: "-100vh", opacity: 0 }))
          ]
        )
      ]
    ),
  ]
})
export class LevelSelectorComponent implements OnInit {
  public menuIn: boolean = true;
  public menuLeaveObs: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public menuLeaves() {
    this.menuLeaveObs.next(true);
  }
  public doors: Game[] = [];
  constructor(private gameService: GameService,
    private router: Router) {
    this.gameService.getMyDoors().then(r => {
      this.doors = r;
    })
  }

  ngOnInit(): void {
  }

  public playDoor(door: Game) {
    this.menuIn = false;
    this.menuLeaveObs.pipe(skip(1)).subscribe(r => {
      this.router.navigate(["code-game"], { queryParams: { "id": door.id } });
    });
  }

}
